export default __webpack_public_path__ + "static/Platten-4b2a404cdda2834ec37c7a29b0dde5dc.jpg";